var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFraudRejected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fraud_rejected_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 15 17",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".fraud_rejected_svg__st0{fill:#979797}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fraud_rejected_svg__st0",
    d: "M14.5 3.7L7.8.4c-.1 0-.2-.1-.3-.1-.1 0-.2 0-.3.1L.5 3.7c-.1.1-.3.3-.3.5 0 4 .9 6.7 2.3 8.5 1.3 1.6 2.9 2.9 4.7 3.8.2.1.4.1.6 0 1.8-.9 3.4-2.2 4.7-3.8 1.4-1.9 2.3-4.5 2.3-8.5 0-.2-.1-.4-.3-.5zm-3 8.3c-1.1 1.4-2.5 2.5-4 3.3-1.5-.8-2.9-2-4-3.3-1.3-1.8-2-4.2-2-7.4l6-3.1 6.1 3.1c.1 2.7-.6 5.2-2.1 7.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fraud_rejected_svg__st0",
    d: "M5.4 5.4c-.3-.3-.7-.3-.9 0s-.3.7 0 .9l2.1 2.1-2.1 2.1c-.2.3-.2.7 0 .9.3.3.7.3.9 0l2.1-2.1 2.1 2.1c.3.3.7.3.9 0 .2-.3.2-.7 0-.9l-2-2 2.1-2.1c.3-.3.3-.7 0-.9s-.7-.3-.9 0L7.5 7.6 5.4 5.4z"
  })));
}
export default SvgFraudRejected;